module.exports = __webpack_public_path__ + "img/sana-malhoa-hotel.314024c5.jpg";